<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <section id="horizontal-form-layouts">
          <div class="row justify-content-md-center">
            <div class="col-md-8">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title font-medium-3" id="horz-layout-card-center">Crear cuenta de empresa</h4>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <div class="card-text p-1">
                      <p>Completa los campos del formulario para registrar a una nueva empresa. <span class="black font-medium-1">La cuenta podrá subir ofertas sin requerir validación.</span></p>
                    </div>
                    <form class="form form-horizontal" [formGroup]="addEmpresaForm">
                      <div class="form-body">
                        <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput1">Nombre de empresa o Razón Social  <span class="requiredAttribute warning">*</span></label>
                          <div class="col-md-9">
                            <input type="text" id="eventRegInput1" autocomplete="organization" class="form-control" placeholder="T-Systems México"
                              formControlName="companyName">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput3">Nombre de responsable <span class="requiredAttribute warning">*</span></label>
                          <div class="col-md-9">
                            <input type="text" id="eventRegInput3" autocomplete="name" class="form-control" placeholder="Arturo Salas Juárez"
                              formControlName="responsableName">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput6">Correo electrónico de responsable <span class="black">(opcional)</span></label>
                          <div class="col-md-9">
                            <input type="email" id="eventRegInput6" autocomplete="email" class="form-control" placeholder="example@auto.com"
                              formControlName="responsableMail">
                          </div>
                        </div>
                        <!-- <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput4">Teléfono <span class="black">(opcional)</span></label>
                          <div class="col-md-9">
                            <input type="tel" maxlength="10" id="eventRegInput4" class="form-control" placeholder="2222778314"
                              formControlName="responsablePhone">
                          </div>
                        </div> -->
                        <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput2">Usuario para acceder al sistema <span class="requiredAttribute warning">*</span></label>
                          <div class="col-md-6">
                            <input type="text" id="eventRegInput2" class="form-control" placeholder="Empresa5718"
                              formControlName="username">
                          </div>
                          <div class="col-md-3">
                            <button type="button" [disabled]="f.username.invalid || (usernameValidated && f.username.value==actualUsername)" (click)="validateUsername()" ngbTooltip="Verificar que no exista el usuario." triggers="hover" placement="top" class="btn btn-block btn-success black font-medium-1">
                              <i class="feather ft-check-circle"></i> Validar
                            </button>
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3" for="eventRegInput5">Contraseña <span class="requiredAttribute warning">*</span></label>
                          <div class="col-md-9">
                            <input type="text" id="eventRegInput5" readonly [value]="addEmpresaForm.get('username').value" class="form-control" placeholder="*******">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                            <div class="flex-right">
                                <ui-switch class="switchery" switchColor="white" color="rgb(150, 122, 220)" formControlName="isActivated"></ui-switch>
                                <label class="card-title ml-1 ds-1 black" for="switcheryColor">Permitir publicar ofertas sin validación</label>
                            </div>
                        </div>
                      </div>
                      <div class="form-actions text-center">
                        <button type="submit" [disabled]="addEmpresaForm.invalid || (!usernameValidated || f.username.value!=actualUsername)" (click)="trySubmit()" class="btn btn-navy font-medium-1">
                          <i class="la la-check"></i> Crear cuenta
                        </button>
                        <p class="text-center text-muted p-2" [hidden]="addEmpresaForm.valid && usernameValidated && f.username.value==actualUsername">El botón estará deshabilitado hasta que completes los campos correctamente</p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
      </div>
    </div>
  </div>
  